import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_DISPOSITION_SAVE } from '../../Store/FleetManagement/FleetDispositionSave/FleetDispositionSaveType'
import { setSaveFleetDisposition } from 'Store/FleetManagement/FleetDispositionSave/FleetDispositionSaveAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* SaveFleetDispositionSaveSaga(req: any): any {
    try {
        yield put(globalLoaderText("Saving values...."));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `asset/fleet/item`, 
            apiMethod :  apiMethod.POST,
            payload : req?.fleetdispositionSave
            
        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setSaveFleetDisposition({response: response, id: req?.fleetdispositionSave?.fleetRequestTransDispoReactivationDetailId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetDispositionSave() {
    yield takeEvery(GET_FLEET_DISPOSITION_SAVE, SaveFleetDispositionSaveSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetDispositionSave()
    ])
}
